<template>
  <div class="home">
    <img src="../assets/img/2016/island_banner.png" width="100%">

  <b-container>
    <b-row>
      <b-col>
      <Carousel />
    </b-col>
    </b-row>
    <!-- Example row of columns -->

    <b-row class="row2">
      <b-col l="3">
       <router-link class="card-link" to="/games/runawayrobot">
        <b-card class="gamecard" title="Runaway Robot" :img-src="require('../assets/img/games/runawayrobot/screenshot.jpg')" img-alt="Image" img-top>
        <b-card-text>Help to guide the robot through the training area by placing robot "commands" along the path. When you click the GO button, the robot will move forward. That's the only command it knows.</b-card-text>
        <b-button to="/games/runawayrobot" class="btn btn-primary" href="#" role="button">Play Now &raquo;</b-button>
      </b-card>
    </router-link>
      </b-col>

      <b-col l="3">
        <router-link class="card-link" to="/games/wordmayhem">
        <b-card class="gamecard" title="Word Mayhem" :img-src="require('../assets/img/games/wordmayhem/screenshot.jpg')" img-alt="Image" img-top>
        <b-card-text>Increase your vocabulary and exercise your brain with our exciting multiplayer word game. Play against other students as you attempt to unscramble the hidden word and find as many smaller words as you can before time expires.</b-card-text>
        <b-button to="/games/wordmayhem" class="btn btn-primary" href="#" role="button">Play Now &raquo;</b-button>
      </b-card>
    </router-link>
      </b-col>

      <b-col l="3">
        <router-link class="card-link" to="/games/code13">
        <b-card class="gamecard" title="Code 13" :img-src="require('../assets/img/games/code13/screenshot.jpg')" img-alt="Image" img-top>
        <b-card-text>Code 13 is a solitaire card game that focuses on adding the values of two cards together. To remove the set of cards the sum of the card values must be 13. <br /><br /><br /></b-card-text>
        <b-button to="/games/code13" class="btn btn-primary" href="#" role="button">Play Now &raquo;</b-button>
      </b-card>
    </router-link>
      </b-col>

    </b-row>

    <b-row>
      <b-col cols="2"></b-col>
      <b-col cols="8" class="home_message">
        <h3>More Games</h3>
        <p>We have many more games, organized by grade level for your convenience. Visit our interactive playground to see them all!</p>
        <p><b-button to="students" class="play_btn">Interactive Playground</b-button></p>
        <p>If you would like to browse an alphabetical list of games, <router-link to="games">click here</router-link>.</p>
      </b-col>
    </b-row>

  </b-container>
    
<b-container>
  <b-card
        border-variant="primary"
        header="Daily Activities"
        header-bg-variant="primary"
        header-text-variant="white"
        align="center"
        class="dailycard"
      >
  
    <div class="panel-body" style="display:inline-block;">
      
        <!-- ***********  Dailies  ********** -->
          <b-container>
            <b-row>
              <b-col>

            <div class="home-daily">
              <router-link to="/games/dws">
              <div class="home-daily-title">Daily Word Search</div>
              <img class="home-daily-img" src="../assets/img/home/dws.jpg">
              </router-link>
              <div class="home-daily-body">
                Every day of the year we have a new word search puzzle for you to solve. Find words quickly to improve your score. Compete for the day&#39;s best score.
              </div>

              <router-link to="/games/dws"><img class="home-daily-btn" src="../assets/img/home/play.jpg"></router-link>
            </div>

          </b-col>
          <b-col l="3">
            <div class="home-daily">
              <router-link to="/games/dailysudoku">
              <div class="home-daily-title">Daily Sudoku</div>
              <img class="home-daily-img" src="../assets/img/home/sudoku.jpg">
            </router-link>
              <div class="home-daily-body">
                If you enjoy sudoku puzzles you will love our new interactive Sudoku game. Try to get the fastest time of the day! There&#39;s a new puzzle each day!
              </div>
              <router-link to="/games/dailysudoku"><img class="home-daily-btn" src="../assets/img/home/play.jpg"></router-link>
            </div>
          </b-col>
          <b-col l="3">
            <div class="home-daily">
              <router-link to="/games/dailyquiz">
              <div class="home-daily-title">Daily Quiz</div>
              <img class="home-daily-img" src="../assets/img/home/dailyquiz.jpg">
            </router-link>
              <div class="home-daily-body">
                Quizzes are fun. So, we&#39;re happy to be able to provide you with a new quiz every day. Even if you don&#39;t know the answers to every question, you&#39;re sure to learn something!
              </div>
              <router-link to="/games/dailyquiz"><img class="home-daily-btn" src="../assets/img/home/play.jpg"></router-link>
            </div>

</b-col>
</b-row>
</b-container>
        <!-- ***********  End Dailies  ********** -->
      
    </div>
  </b-card>
</b-container>


<b-container>
        <b-row>
      <b-col cols="2"></b-col>
      <b-col cols="8" class="home_message">
        <h3>Our site uses Flash</h3>
        <p>In order to properly view most of our content you will need to install the Flash plugin. This is an easy process and we have prepared some help in case you are unsure.</p>
        <p><b-button to="help" variant="primary">Learn More</b-button></p>
      </b-col>
    </b-row>
  </b-container>
    
  </div>
</template>

<script>
//import Cards from './Cards.vue';
import Carousel from './Carousel.vue';

export default {
  name: 'Home',
  components: {
    Carousel
  },
  props: {
    msg: String
  },
  methods: {
    gameClick(game){
      this.$router.push(game);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.home-main-row {
  padding-top:4px;
  margin-top:4px;
}

.home-main-column {
  padding-left:7px;
  padding-right:3px;
}

.home-secondary-column {
  padding-left:3px;
  padding-right:7px;
}

.home-carousel {
  border-color:black;
}

.carousel-caption {
  bottom: 0px;
  text-shadow: 2px 2px 1px rgba(0, 0, 0, 1.0);
}

.carousel-indicators {
  bottom: 0px;
}

.home-carousel-heading {
  background:black !important;
  margin:3px 3px 1px 3px;
  padding:5px;
  border-bottom:0px;
}

.home-carousel-body {
  padding:0px 3px 0px 3px;
  border-bottom:0px;
}

.home-carousel-footer {
  padding:5px;
  background:@lpDkBlue;
  color:white;
  border-top:0px;
  margin:1px 3px 3px 3px;
}
.dailies-panel {
  margin-top:10px;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.6);
  transition: 0.3s;
  border-radius: 12px;
}

.dailies-panel .panel-heading {
  border-radius: 10px 10px 0 0;
}


.home-daily {
  background-image:url('../assets/img/home/daily.jpg');
  width:228px;
  height:222px;
  overflow:hidden;
  margin:0px 20px 0px 20px;

}

.home-daily-title {
  height:28px;
  text-align:center;
  font-size:16px;
  font-weight:bold;
  padding-top:2px;
}

.home-daily-img {
  margin-left:5px;
}

.home-daily-body {
  font-size:11px;
  line-height:13px;
  padding:2px 5px 0px 7px
}

.home-daily-btn {
  margin-left:60px;
  top:auto;
  position:relative;
  bottom:-16px;
}


.panel {
  margin-bottom: 21px;
  background-color: #ffffff;
  border: 1px solid transparent;
  border-radius: 0;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
.panel-body {
  padding: 15px;
}
.panel-heading {
  padding: 10px 15px;
  border-bottom: 1px solid transparent;
}
.panel-heading > .dropdown .dropdown-toggle {
  color: inherit;
}
.panel-title {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 17px;
  color: inherit;
}
.panel-title > a {
  color: inherit;
}
.panel-primary {
  border-color: #008cba;
}
.panel-primary > .panel-heading {
  color: #ffffff;
  background-color: #008cba;
  border-color: #008cba;
}
.panel-primary > .panel-heading + .panel-collapse > .panel-body {
  border-top-color: #008cba;
}
.panel-primary > .panel-heading .badge {
  color: #008cba;
  background-color: #ffffff;
}
.panel-primary > .panel-footer + .panel-collapse > .panel-body {
  border-bottom-color: #008cba;
}

.row2 {
  margin-top: 40px;
}

.gamecard {
  border-radius: 50px;
  overflow: hidden;
  min-height: 550px;
}

.dailycard {
  border-radius: 20px;
  overflow: hidden;
}

.card-link a {
  text-decoration: none;
}

.card-link a:hover {
  text-decoration: none;
}

.play_btn {
  background-color: #FFCC00;
  color: black !important;
}

.play_btn:hover {
  color: white !important;

}

.home_message {
  width: 600px;
  margin-top: 60px;
  margin-bottom: 60px;
}
.home_message a {
  color: black;
  font-weight: bold;
}
.home_message p {
  font-size:16pt;
}
</style>
